import { render } from "./DepositSuccessfully.vue?vue&type=template&id=75e5dbb4"
import script from "./DepositSuccessfully.vue?vue&type=script&lang=js"
export * from "./DepositSuccessfully.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__